import { VendorRouteImport } from './Import'
const { RoutesMap, VendorList, VendorDetails, VendorServiceList } = VendorRouteImport


const VendorRoute = () => {
    return [
        {
            path: RoutesMap.VENDOR_LIST.path,
            element: <VendorList />
        },
        {
            path: RoutesMap.VENDOR_DETAILS.path,
            element: <VendorDetails />
        },
        {
            path: RoutesMap.VENDOR_SERVICE_LIST.path,
            element: <VendorServiceList />
        },

    ]
}

export default VendorRoute;